<script setup lang="ts"></script>

<template>
  <svg
    viewBox="0 0 20 20"
    fill="currentColor"
    data-slot="icon"
    aria-hidden="true"
    class="color-[#05df72] w-5 h-5"
  >
    <path
      d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
      clip-rule="evenodd"
      fill-rule="evenodd"
    ></path>
  </svg>
</template>
